import { BonusGame } from '@root/src/types';

export type GameState = {
    name: GameStateType;
    onEnter: (changeState: (stateName: GameStateType) => void) => void;
    onExit?: () => void;
};

export type StatesTypes = {
    init: GameStateType;
    notStarted: GameStateType;
    game: GameStateType;
    results: GameStateType;
    bigWin: GameStateType;
    wheelOfFortune: GameStateType & BonusGame;
    wheelOfFortuneDouble: GameStateType;
    cashReels: GameStateType & BonusGame;
    cashReelsDouble: GameStateType;
    plinko: GameStateType & BonusGame;
    ballSpin: GameStateType & BonusGame;
};

export type GameStateType =
    | 'INIT'
    | 'NOT_STARTED'
    | 'GAME'
    | 'RESULTS'
    | 'BIG_WIN'
    | BonusGame
    | 'CASH_REELS_DOUBLE'
    | 'FORTUNE_WHEEL_DOUBLE';

export const gameStates: StatesTypes = {
    init: 'INIT',
    notStarted: 'NOT_STARTED',
    game: 'GAME',
    results: 'RESULTS',
    bigWin: 'BIG_WIN',
    wheelOfFortune: 'FORTUNE_WHEEL',
    cashReels: 'CASH_REELS',
    plinko: 'PLINKO',
    ballSpin: 'BALL_SPIN',
    cashReelsDouble: 'CASH_REELS_DOUBLE',
    wheelOfFortuneDouble: 'FORTUNE_WHEEL_DOUBLE'
};

export function getGameStateById(gameId: BonusGame): GameStateType {
    if (gameId === 'PLINKO') return gameStates.plinko;
    if (gameId === 'CASH_REELS') return gameStates.cashReels;
    if (gameId === 'FORTUNE_WHEEL') return gameStates.wheelOfFortune;
    if (gameId === 'BALL_SPIN') return gameStates.ballSpin;
    throw new Error('Invalid game');
}
